import { render, staticRenderFns } from "./ModalSelectPvpAction.vue?vue&type=template&id=02632509&scoped=true"
import script from "./ModalSelectPvpAction.vue?vue&type=script&lang=js"
export * from "./ModalSelectPvpAction.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectPvpAction.vue?vue&type=style&index=0&id=02632509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02632509",
  null
  
)

export default component.exports